import { SingleSelectDropdown } from '@cc-shopping/ui/composites/SingleSelectDropdown';
import { memo, useCallback } from 'react';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../../store/Context';
import { FilterType, type SortOffersByType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import type { FilterComponentProps } from './types';
import { createApplyAndNotify } from './utils';

export const SortByFilter = memo(
  ({ options, forceClose, onAfterChange, labelledById }: FilterComponentProps) => {
    const { sortBy, handleSingleFormUpdate, handleApplyFilters } = useOffersFilterStore(
      useShallow((state: OffersFilterStoreState) => ({
        sortBy: state.filterFormState.sortBy,
        handleSingleFormUpdate: state.handleSingleFormUpdate,
        handleApplyFilters: state.handleApplyFilters,
      })),
    );

    const { fireSortByUpdateEvents } = useFiltersAnalytics();

    const handleChange = useCallback(
      (selectedValue: string) => {
        const sortValue = selectedValue as SortOffersByType;
        createApplyAndNotify(
          handleSingleFormUpdate,
          handleApplyFilters,
          onAfterChange,
        )({
          type: FilterType.SORT_BY,
          value: sortValue,
        });
        fireSortByUpdateEvents(sortValue);
      },
      [handleSingleFormUpdate, handleApplyFilters, onAfterChange, fireSortByUpdateEvents],
    );

    return (
      <SingleSelectDropdown
        labelledById={labelledById}
        label="Sort by"
        labelPrefix={labelledById ? '' : 'Sort by: '}
        selectedOption={sortBy}
        options={options.sortByOptions}
        onChange={handleChange}
        forceClose={forceClose}
      />
    );
  },
);
